/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { useFormik } from "formik";
import classNames from "clsx";
import * as Yup from "yup";

import { login } from "../core/_requests";
import { useAuth } from "../core/Auth";
import { getRuntimeConfig } from "@/config/runtimeConfig";

import { Version } from "./Version";

const initialValues = {
	user: "dev@sintegrada.com.br",
	password: "qwe123",
};

export function Login() {
	const [loading, setLoading] = useState(false);
	const { saveAuth } = useAuth();
	const intl = useIntl();

	const loginSchema = Yup.object().shape({
		user: Yup.string()
			.min(3, intl.formatMessage({ id: "AUTH.VALIDATION.MIN_LENGTH_3" }))
			.max(50, intl.formatMessage({ id: "AUTH.VALIDATION.MAX_LENGTH_50" }))
			.required(intl.formatMessage({ id: "AUTH.VALIDATION.USER_REQUIRED" })),
		password: Yup.string()
			.min(3, intl.formatMessage({ id: "AUTH.VALIDATION.MIN_LENGTH_3" }))
			.max(50, intl.formatMessage({ id: "AUTH.VALIDATION.MAX_LENGTH_50" }))
			.required(intl.formatMessage({ id: "AUTH.VALIDATION.PASSWORD_REQUIRED" })),
	});

	const formik = useFormik({
		initialValues,
		validationSchema: loginSchema,
		onSubmit: async (values, { setStatus, setSubmitting }) => {
			setLoading(true);
			try {
				const response = await login(values.user, values.password);
				const auth = response.data;

				if (auth) {
					auth.issued_by_client_id = getRuntimeConfig().passwordGrantClientId;
					saveAuth(auth);
				}
			} catch (error: any) {
				console.error(error);
				saveAuth(undefined);
				setStatus(intl.formatMessage({ id: "AUTH.VALIDATION.INVALID_LOGIN" }));
				setSubmitting(false);
				setLoading(false);
			}
		},
	});

	return (
		<form
			className="form w-100"
			onSubmit={formik.handleSubmit}
			noValidate
			id="kt_login_signin_form"
		>
			<div className="text-center mb-10">
				<h1 className="text-dark mb-3">Login</h1>
			</div>

			{formik.status && (
				<div className="mb-lg-15 alert alert-danger">
					<div className="alert-text font-weight-bold">{formik.status}</div>
				</div>
			)}

			<div className="fv-row mb-10">
				<input
					placeholder={intl.formatMessage({ id: "AUTH.VALIDATION.PLACEHOLDER_EMAIL" })}
					{...formik.getFieldProps("user")}
					className={classNames(
						"form-control form-control-lg form-control-solid",
						{ "is-invalid": formik.touched.user && formik.errors.user },
						{
							"is-valid": formik.touched.user && !formik.errors.user,
						}
					)}
					type="text"
					name="user"
					autoComplete="off"
				/>

				{formik.touched.user && formik.errors.user && (
					<div className="fv-plugins-message-container">
						<span className="text-danger" role="alert">
							{formik.errors.user}
						</span>
					</div>
				)}
			</div>

			<div className="fv-row mb-10">
				<input
					type="password"
					placeholder={intl.formatMessage({ id: "AUTH.VALIDATION.PLACEHOLDER_PASSWORD" })}
					autoComplete="off"
					{...formik.getFieldProps("password")}
					className={classNames(
						"form-control form-control-lg form-control-solid",
						{
							"is-invalid": formik.touched.password && formik.errors.password,
						},
						{
							"is-valid": formik.touched.password && !formik.errors.password,
						}
					)}
				/>

				{formik.touched.password && formik.errors.password && (
					<div className="fv-plugins-message-container">
						<div className="fv-help-block">
							<span role="alert">{formik.errors.password}</span>
						</div>
					</div>
				)}
			</div>

			<div className="text-center">
				<button
					type="submit"
					id="kt_sign_in_submit"
					className="btn btn-lg btn-primary w-100 mb-5"
					disabled={formik.isSubmitting || !formik.isValid}
				>
					{!loading && (
						<span className="indicator-label">
							{intl.formatMessage({ id: "AUTH.LOGIN.BUTTON" })}
						</span>
					)}
					{loading && (
						<span className="indicator-progress" style={{ display: "block" }}>
							{intl.formatMessage({ id: "AUTH.GENERAL.LOADING" })}
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					)}
				</button>
			</div>

			<div className="d-flex flex-row justify-content-between">
				<div>
					<label className="text-gray-600">
						{intl.formatMessage({ id: "AUTH.VALIDATION.DO_NOT_HAVE_AN_ACCOUNT" })}
					</label>

					<Link to="/auth/create-account" className="link-primary fs-6 fw-bolder ms-2">
						{intl.formatMessage({ id: "AUTH.VALIDATION.CREATE_ACCOUNT" })}?
					</Link>
				</div>

				<Version />
			</div>
		</form>
	);
}
